<template>
	<div class="map">
		<div class="crumb" v-show="crumb.length > 0">
			<!--   <div
        @click="back"
        v-show="currentCity !== 'china'"
        style="cursor: pointer"
      >
        中国
      </div> -->
			<div v-for="(item, index) in crumb" @click="crumbClick(item, index)" :key="index" style="cursor: pointer"
				v-if="item != '浙江省'">
				{{ item }}
				<span style="margin: 0 5px" v-if="index != crumb.length - 1">-</span>
			</div>
		</div>
		<div ref="map" style="width: 100%; height: 100%"></div>
	</div>
</template>
<script>
	import cityData from "../api/city.json";
	import {
		getGeojson
	} from "../api/dataView";
	let YEAR = "" // 公共变量方便访问 设置 toolTip
	export default {
		name: "chart-map",
		props: {
			mapData: {
				type: Array,
				default: () => [],
			},
			// 根据选择器来变换标题
			year: {
				type: String | Number,
				default: () => "",
			},
			city: {
				type: Object,
				default: () => {
					return {
						name: "china",
						code: "100000",
					};
				}
			},
		},
		data() {
			return {
				adcodeData: [],
				zhixiashi: ["北京市", "上海市", "天津市", "重庆市"],
				currentCity: "china",
				crumb: [],
				crumbCodes: [],
				chart: null,
				config: {
					visualMap: {
						show: false,
						min: 0,
						max: 40000,
						textStyle: {
							color: "#fff",
						},
						bottom: 120,
						left: 50,
						inRange: {
							// color: ["#1F476F", "#3286FF", "#55B4B9"],
							color: ["#5ea7fb"],
						},
					},
					tooltip: {
						trigger: "item",
						backgroundColor: "none",
						showDelay: 200,
						formatter(params) {
							// console.log(YEAR,"YEAR");
							if (!params.data) return "";
							let {
								name,
								value,
								sumValid,
								rank
							} = params.data;
							return `<div
style="width:217px;height:122px;background-size:100% 100%;background-image:url(${require("../assets/map-float.png")});position:relative;">
<div style="position:absolute;left:35px;top:5px;">${name}</div>
<div style="padding-top:35px;padding-left:15px;">
<div style="font-size:14px;color:#BDBDBD;">排名：${rank}</div>
<div style="font-size:16px;margin-top:5px;">${
            String(YEAR).length == 0 ? "历年商标总量" : "当年申请量"
          }：${value}</div>
<div style="font-size:16px;margin-top:5px;">${
            String(YEAR).length == 0 ? "历年注册总量" : "有效注册量"
          }：${sumValid}</div>
</div>
`;
						},
						//   };
						// this.chart.setOption(this.config);
						//      this.chart = this.$chart.init(this.$refs.map);
					},
					series: [
						//           {
						//             type: 'map3D',
						//             name: 'china',
						//             selectedMode:"single",//地图高亮单选
						//             boxDepth:90,//地图倾斜度
						//             regionHeight:5,//地图高度
						//             map: 'china',
						//             viewControl:{
						//               distance:100,//地图视角 控制初始大小
						//               minBeta: -180,
						//               maxBeta: 180
						//             },
						//             label: {
						//               show: true,//是否显示市
						//               textStyle:{
						//                 color:"#fff",//文字颜色
						//                 fontSize:12,//文字大小
						//                 backgroundColor:"rgba(0,0,0,0)",//透明度0清空文字背景
						//               }
						//             },
						//               itemStyle: {
						//                 normal: {
						//                   areaColor: '#4A9DE4',
						//                   borderColor: '#A2D9FC',
						//                   borderWidth: 0.5,
						//                   opacity: 1
						//                 },
						//                 emphasis: {
						//                   areaColor: '#fff',
						//                   shadowOffsetX: 10,
						//                   shadowOffsetY: 10,
						//                   shadowBlur: 2,
						//                   borderWidth: 0,
						//                   shadowColor: "#387DFE",
						//                   borderColor: 'rgba(0, 0, 0, 0)',
						//                 }
						//               },
						//             emphasis:{
						//               label:{
						//                 show: true,//是否显示高亮
						//                 textStyle:{
						//                   color: '#fff',//高亮文字颜色
						//                 }
						//               },
						//               itemStyle:{
						//                 color: '#0489d6',//地图高亮颜色
						//               }
						//             },
						//             silent: true,
						//             instancing: true,
						//             //高亮市区  echarts  bug 不生效
						//             data:[],
						//             light: { // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
						//               main: { // 场景主光源的设置，在 globe 组件中就是太阳光。
						//                 color: '#fff', //主光源的颜色。[ default: #fff ]
						//                 intensity: 0.8, //主光源的强度。[ default: 1 ]
						//                 shadow: true, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
						// //shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
						//                 alpha: 60, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
						//                 beta: -10 // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
						//               },
						//               ambient: { // 全局的环境光设置。
						//                 color: '#fff', // 环境光的颜色。[ default: #fff ]
						//                 intensity: 0.5 // 环境光的强度。[ default: 0.2 ]
						//               }
						//             },
						//             rotateSensitivity: 2,
						//             zoomSensitivity: 2,
						//             animation: true,	// 是否开启动画。[ default: true ]
						//             animationDurationUpdate: 1000,	// 过渡动画的时长。[ default: 1000 ]
						//             animationEasingUpdate: 'cubicInOut'	// 过渡动画的缓动效果。[ default: cubicInOut ]
						//           }
						{
							// 地图配置
							name: "地图",
							type: "map",
							map: "china", // 自定义扩展图表类型
							aspectScale: 0.75, // 长宽比
							roam: true,
							labelLine: {
								show: true,
							},
							label: {
								normal: {
									show: true,
									textStyle: {
										color: "#fff",
									}, // 相对的百分比
									position: ["50%", "50%"],
								},
								emphasis: {
									show: true,
									textStyle: {
										color: "#000",
									},
								},
							},
							itemStyle: {
								normal: {
									areaColor: "#5ea7fb",
									borderColor: "#69d8f6",
									borderWidth: 2,
									opacity: 1,
								},
								emphasis: {
									areaColor: "#fff",
									shadowOffsetX: 3,
									shadowOffsetY: 3,
									shadowBlur: 3,
									borderWidth: 0,
									shadowColor: "#5ea7fb",
									borderColor: "rgba(0, 0, 0, 0.5)",
								},
							},
							data: [],
						},
					],
				},
				option: {},
				cityLevel: 0,
				mapJson: {},
			};
		},
		watch: {
			year(newValue) {
				// console.log(newValue,"newValue")
				YEAR = newValue
			},
			mapData: {
				handler(e) {
					// console.log("mapData")
					let options = {
						...this.config,
					};
					// console.log(mapData)
					let mapData = e || [];
					// console.log(mapData);
					let adcodeData = this.mapJson.features.map((i) => {
						let item = i.properties;
						// console.log(item.adcode)
						return {
							adcode: item.adcode,
							name: item.name,
							level: item.level,
						};
					});
					// console.log(adcodeData)
					mapData.forEach((i) => {
						let f = adcodeData.find((_i) => _i.name === i.name);
						if (f) {
							i.adcode = f.adcode;
						}
					});
					// console.log(mapData)
					options.series[0].data = mapData;
					this.setDataMinMax(this.mapData, options);
					this.chart.setOption(options);
				},
			},
			crumb(newValue) {
				// 记录当前城市树状级
				// 0 中国 1省份 2市 3区域
				this.cityLevel = newValue.length;
				if (newValue.length === 0) this.crumbCodes = [];
			},
		},
		mounted() {
			// this.getToolTip();
			// YEAR = this.$root.year;
			YEAR= this.year;
			// console.log(this.$root.year)
			this.changeMapNew(this.city.name, this.city.code, "init");
		},
		methods: {
			async getGeojson(num = "100000") {
				let res = await getGeojson({
					num,
				});
				if (res.data.code === 200) {
					// console.log(res)
					return res.data.data;
				}				
			},
			back() {
				this.crumb = [];
				this.changeMapNew("china", "100000");
			},
			initMap() {
				let self = this;
				this.chart.on("click", function(param) {

					// 补丁操作
					if (self.crumb.length === 2) self.$emit("rightBottom", param.name)
					// 补丁操作
					if (!param.data) param.data = self.adcodeData.filter(item => item.name == param.name)[0]

					// 都要更新地图 但是3级不请求数据
					if (self.zhixiashi.includes(self.currentCity)) {
						self.$emit("areaClick", param.name, self.crumb);
					}
					try {
						self.changeMapNew(param.name, param.data.adcode);
					} catch (error) {
						self.changeMapNew(param.name, "");
					}
				});
			},

			async changeMapNew(name, adcode, init) {
				let data;
				let adcodeData;

				// 避免没有adcode和三级adcode
				if (adcode && this.cityLevel < 3) {
					data = await this.getGeojson(adcode);
					this.mapJson = data;
					adcodeData = data.features.map((i) => {
						let item = i.properties;
						return {
							adcode: item.adcode,
							name: item.name,
							level: item.level,
						};
					});
					this.$chart.registerMap(name, data);
					// 补丁
					this.adcodeData = adcodeData;
				}

				let options = {
					...this.config,
				};
				options.series[0].map = name;

				let mapData = [...this.mapData];


				// console.log(adcodeData)
				if (adcodeData) {
					mapData.forEach((i) => {
						// let f = adcodeData.find((_i) => _i.name === i.name);
						// if (f) {
						// 	i.adcode = f.adcode;
						// }else{
						// 	console.log(i)
						// }
					});
				}

				// console.log(mapData)

				options.series[0].data = mapData;



				if (name === "海南省") {
					//由于海南地图包括南海及南海诸岛在内的大片区域，所以显示海南地图时，要将地图放大，并设置海南岛居中显示
					options.series[0].center = [109.844902, 19.0392];
					options.series[0].layoutCenter = ["50%", "50%"];
					options.series[0].layoutSize = "600%";
					options.series[0].zoom = 1;
				} else if (name === "china") {
					//非显示海南时，将设置的参数恢复默认值
					options.series[0].center = [100, 36];
					options.series[0].layoutCenter = ["20%", "70%"];
					options.series[0].layoutSize = undefined;
					options.series[0].zoom = 1.6;
				} else {
					//非显示海南时，将设置的参数恢复默认值
					options.series[0].center = undefined;
					options.series[0].layoutCenter = undefined;
					options.series[0].layoutSize = undefined;
					options.series[0].zoom = 1;
				}
				if (name !== "china") {
					// 不重复添加
					if (this.crumb.indexOf(name) === -1 && this.crumb.length < 3) {
						this.crumb.push(name);
						this.crumbCodes.push(adcode);
					}
				}
				//当前城市名
				this.currentCity = name;

				//地图 echarts 生成
				this.chart = this.$chart.init(this.$refs.map);
				this.chart.setOption(options);
				this.$emit("changeMap", this.crumb);
				// if (!this.zhixiashi.includes(this.crumb[0])) this.$emit("changeMap", this.crumb);
				if (init) {
					const code = this.$route.query.code2 || '210300'
					this.initMap() // 大致跳转下 如果能直接显示 不要跳转了
					// this.$nextTick(() => this.changeMapNew("鞍山市", 210300));
					this.$nextTick(() => this.changeMapNew(cityData[code], code));
				}					
			},
			// async changeMap(name, city, init) {
			//   let _name = this.cityNameSwitch(name)
			//   if (city) {
			//     //市级以下
			//     // require(`../../node_modules/echarts-china-cities-js/src/${_name}/${city}.js`)
			//     name = city
			//   } else if (name !== 'china') {
			//     //省
			//     // require(`../../node_modules/echarts/map/js/province/${name}.js`)
			//   } else {
			//     //全国
			//
			//     // require(`../../node_modules/echarts/map/js/${name}.js`)
			//   }
			//   let options = {...this.config}
			//   console.log(_name);
			//   if (_name === '海南' && !city) { //由于海南地图包括南海及南海诸岛在内的大片区域，所以显示海南地图时，要将地图放大，并设置海南岛居中显示
			//     options.series[0].center = [109.844902, 19.0392];
			//     options.series[0].layoutCenter = ['50%', '50%'];
			//     options.series[0].layoutSize = "600%";
			//   } else { //非显示海南时，将设置的参数恢复默认值
			//     options.series[0].center = undefined;
			//     options.series[0].layoutCenter = undefined;
			//     options.series[0].layoutSize = undefined;
			//   }
			//   if (!city) {
			//     options.series[0].map = _name;
			//     if (_name !== 'china') this.crumb[0] = _name;
			//   } else {
			//     city = city.replace("市", "");
			//     this.crumb[1] = city
			//     options.series[0].map = city;
			//   }
			//   this.setDataMinMax(this.mapData, options);
			//   options.series[0].data = this.mapData;
			//   //当前城市名
			//   this.currentCity = name;
			//   //当前城市等级
			//   this.cityLevel = this.crumb.length;
			//   //地图 echarts 生成
			//
			//   this.chart = this.$chart.init(this.$refs.map)
			//   this.chart.setOption(options);
			//   //change
			//   if (!init) this.$emit('changeMap', this.crumb)
			// },
			setDataMinMax(data, options) {
				if (!data || !Array.isArray(data) || data.length === 0) {
					options.visualMap.min = 0;
					options.visualMap.max = 0;
					return;
				}
				let values = data.map((i) => i.value);
				let max = Math.max(...values);
				let min = Math.min(...values);
				// console.log(min, max);
				options.visualMap.min = min;
				options.visualMap.max = max;
			},
			crumbClick(name, index) {
				this.crumb = this.crumb.slice(0, index + 1);
				this.crumbCodes = this.crumbCodes.slice(0, index + 1);
				this.cityLevel = this.crumb.length;				
				this.changeMapNew(name, this.crumbCodes[this.crumbCodes.length - 1], true);
			},
			// copy(data) {
			//   try {
			//     return JSON.parse(JSON.stringify(data));
			//   } catch (error) {
			//     return "";
			//   }
			// },
		},
	};
</script>

<style lang="less" scoped>
	.map {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.crumb {
		display: flex;
		position: absolute;
		left: 25px;
		top: 50px;
		//z-index: 98;
		background: rgba(0, 0, 0, 0.5);
		padding: 5px 30px;
		font-size: 14px;
		// background: red;
		box-sizing: border-box;
		z-index: 999;
		border: 1px solid rgba(46, 96, 153, 0.5);
	}
</style>
